import React from "react";

import LeftBar from "@v1/components/left-bar/LeftBar";
import ChooseTemplateOverlay from "@v1/components/new-page-flow/ChooseTemplateOverlay";
import { setLeftBarActiveTab } from "@v1/reducers/ui-reducer";
import { useEditorDispatch } from "@v1/store/store";

import { EditorLayout } from "./EditorLayout";

type TemplateLibraryEditorLayoutProps = React.PropsWithChildren;

const TemplateLibraryEditorLayout = ({
  children,
}: TemplateLibraryEditorLayoutProps) => {
  const dispatch = useEditorDispatch();
  dispatch(setLeftBarActiveTab(null));

  const templateLibraryEditorOverlays = (
    <>
      <LeftBar
        showElementSpecificContent={false}
        fullPageOverlay={<ChooseTemplateOverlay />}
      />
    </>
  );

  return (
    <EditorLayout toRenderOverEditor={templateLibraryEditorOverlays}>
      {children}
    </EditorLayout>
  );
};

export default TemplateLibraryEditorLayout;
